/**
 * Lions Clubs International District 303 Theme Configuration
 * Brand colors and design system
 */

export const colors = {
  // Primary Lions Colors
  royalBlue: '#002D72',
  lionsGold: '#FDB913',
  
  // Neutral Colors
  white: '#FFFFFF',
  lightGray: '#F5F5F5',
  gray: '#9E9E9E',
  darkGray: '#424242',
  black: '#212121',
  
  // Semantic Colors
  success: '#4CAF50',
  error: '#F44336',
  warning: '#FF9800',
  info: '#2196F3',
  
  // Text Colors
  textPrimary: '#212121',
  textSecondary: '#757575',
  textDisabled: '#BDBDBD',
};

export const typography = {
  fontFamily: {
    primary: "'Open Sans', sans-serif",
    chinese: "'Noto Sans TC', sans-serif",
    display: "'Open Sans', 'Noto Sans TC', sans-serif",
  },
  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
  },
  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75,
  },
};

export const shadows = {
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
};

// MUI Theme configuration
export const muiTheme = {
  palette: {
    primary: {
      main: colors.royalBlue,
      light: '#1565C0',
      dark: '#001E4D',
      contrastText: colors.white,
    },
    secondary: {
      main: colors.lionsGold,
      light: '#FFCA28',
      dark: '#F57F17',
      contrastText: colors.royalBlue,
    },
    error: { main: colors.error },
    warning: { main: colors.warning },
    info: { main: colors.info },
    success: { main: colors.success },
    background: {
      default: colors.white,
      paper: colors.lightGray,
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      disabled: colors.textDisabled,
    },
  },
  typography: {
    fontFamily: typography.fontFamily.display,
    h1: { fontSize: typography.fontSize['5xl'], fontWeight: typography.fontWeight.bold, lineHeight: typography.lineHeight.tight },
    h2: { fontSize: typography.fontSize['4xl'], fontWeight: typography.fontWeight.bold, lineHeight: typography.lineHeight.tight },
    h3: { fontSize: typography.fontSize['3xl'], fontWeight: typography.fontWeight.semibold, lineHeight: typography.lineHeight.normal },
    h4: { fontSize: typography.fontSize['2xl'], fontWeight: typography.fontWeight.semibold, lineHeight: typography.lineHeight.normal },
    h5: { fontSize: typography.fontSize.xl, fontWeight: typography.fontWeight.medium, lineHeight: typography.lineHeight.normal },
    h6: { fontSize: typography.fontSize.lg, fontWeight: typography.fontWeight.medium, lineHeight: typography.lineHeight.normal },
    body1: { fontSize: typography.fontSize.base, lineHeight: typography.lineHeight.normal },
    body2: { fontSize: typography.fontSize.sm, lineHeight: typography.lineHeight.normal },
  },
  shape: { borderRadius: 8 },
  shadows: [
    'none', shadows.sm, shadows.base, shadows.md, shadows.lg, shadows.xl,
    shadows.xl, shadows.xl, shadows.xl, shadows.xl, shadows.xl, shadows.xl,
    shadows.xl, shadows.xl, shadows.xl, shadows.xl, shadows.xl, shadows.xl,
    shadows.xl, shadows.xl, shadows.xl, shadows.xl, shadows.xl, shadows.xl, shadows.xl,
  ],
};
